import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ModalPortal } from "../../SharedModule/components/ModalPortal";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { TimesheetsService } from "../services/timesheets";
import { ModalMoreInfoTimeEntry } from "../components/ModalMoreInfoTimeEntry";

// Shared by QueryResultsPage, ApproveTimeByUserPage and TimesPage: the "More
// Info" modal (entry action history) is wired up identically in all three.
export const useMoreInfoTimeEntryModal = () => {
  const dispatch = useDispatch();

  const modalMoreInfoRef = useRef<undefined>(undefined);
  const [isLoadingActions, setIsLoadingActions] = useState(true);
  const [entryActions, setEntryActions] = useState(undefined);

  const showMoreInfoModal = () => {
    (modalMoreInfoRef.current as any).show(true);
  };
  const closeMoreInfoModal = () => {
    (modalMoreInfoRef.current as any).show(false);
  };

  const showMoreInfo = async (entry: { timeEntryId: number }) => {
    setIsLoadingActions(true);
    showMoreInfoModal();
    await TimesheetsService.getTimeEntryInfo(entry.timeEntryId)
      .then((response) => {
        if (response.data.data.length > 0) {
          setEntryActions(response.data.data);
          setIsLoadingActions(false);
        } else {
          dispatch(
            addToast({ mode: "error", message: "Time entry was not found" })
          );
        }
      })
      .catch((error) => {
        dispatch(addToast({ mode: "error", message: error }));
      });
  };

  const moreInfoModalPortal = (
    <ModalPortal ref={modalMoreInfoRef}>
      <ModalMoreInfoTimeEntry
        btnCancel={closeMoreInfoModal}
        type="moreInfoModal"
        actions={entryActions}
        isLoadingActions={isLoadingActions}
      />
    </ModalPortal>
  );

  return { showMoreInfo, moreInfoModalPortal };
};
